import Vue from 'vue'
import Router from 'vue-router'
//备份原型对象已有的push|replace方法
let push = Router.prototype.push;
let replace = Router.prototype.replace;
//重写VueRouter.prototype原型对象的push|replace方法
Router.prototype.push = function (location) {
  //调用push方法且篡改push方法内部this指向->vueRouter类的实例
  push.call(this, location, () => { }, () => { });
}
Router.prototype.replace = function (location) {
  //调用push方法且篡改push方法内部this指向->vueRouter类的实例
  replace.apply(this, [location, () => { }, () => { }]);
}
Vue.use(Router)
// 在路由加载的时候首次进来要按需加载路由，首页加载慢的问题，不要使用import换成require
export const constantRouteMap = [
  {
    path: '/',
    redirect: '/home'
  },
  // 首页
  {
    path: '/home',
    component: resolve => require(['@/views/index/index'], resolve),
    name: 'index',
    meta: {
      title: '咸阳市干部教育在线'
    }
  },
  {
    path: '/notice/swiperNotice',
    component: resolve => require(['@/views/notice/swiperNotice'], resolve),
    name: 'swiperNotice',
    meta: {
      title: '轮播详情'
    }
  },
  {
    path: '/notice/noticeDetail',
    component: resolve => require(['@/views/notice/noticeDetail'], resolve),
    name: 'noticeDetail',
    meta: {
      title: '公告详情'
    }
  },
  {
    path: '/notice/newsDetail',
    component: resolve => require(['@/views/notice/newsDetail'], resolve),
    name: 'newsDetail',
    meta: {
      title: '新闻详情'
    }
  },
  {
    path: '/notice/noticeList',
    component: resolve => require(['@/views/notice/noticeList'], resolve),
    name: 'noticeList',
    meta: {
      title: '通知公告'
    }
  },
  {
    path: '/notice/newsList',
    component: resolve => require(['@/views/notice/newsList'], resolve),
    name: 'newsList',
    meta: {
      title: '干教资讯'
    }
  },
  {
    path: '/learning',
    component: resolve => require(['@/views/learning/index'], resolve),
    redirect: '/learning/index',
    children: [
      {
        path: '/learning/index',
        component: resolve => require(['@/views/learning/study'], resolve),
        name: 'learning',
        meta: {
          title: '学习课堂'
        }
      },
      {
        path: '/learning/studyClass',
        component: resolve => require(['@/views/learning/study/class'], resolve),
        name: 'studyClass',
        meta: {
          title: '学习课堂'
        }
      },
      {
        path: '/learning/work',
        component: resolve => require(['@/views/learning/work'], resolve),
        name: 'work',
        meta: {
          title: '学习课堂'
        }
      },
      {
        path: '/learning/workList',
        component: resolve => require(['@/views/learning/work/workList'], resolve),
        name: 'workList',
        meta: {
          title: '学习课堂'
        }
      },
      {
        path: '/learning/workDetail',
        component: resolve => require(['@/views/learning/work/workDetail'], resolve),
        name: 'workDetail',
        meta: {
          title: '学习课堂'
        }
      },
      {
        path: '/learning/statistics',
        component: resolve => require(['@/views/learning/statistics'], resolve),
        name: 'statistics',
        meta: {
          title: '学习课堂'
        }
      },
      {
        path: '/learning/note',
        component: resolve => require(['@/views/learning/note'], resolve),
        name: 'note',
        meta: {
          title: '学习课堂'
        }
      },
      {
        path: '/learning/noteDetail',
        component: resolve => require(['@/views/learning/note/noteDetail'], resolve),
        name: 'noteDetail',
        meta: {
          title: '学习课堂'
        }
      },
      {
        path: '/learning/certificate',
        component: resolve => require(['@/views/learning/certificate'], resolve),
        name: 'certificate',
        meta: {
          title: '学习课堂'
        }
      },
      {
        path: '/learning/class',
        component: resolve => require(['@/views/learning/class'], resolve),
        name: 'class',
        meta: {
          title: '学习课堂'
        }
      }
    ]
  },
  {
    path: '/learning/detail',
    component: resolve => require(['@/views/learning/detail'], resolve),
    name: 'learnDetail',
    meta: {
      title: '学习课堂详情'
    }
  },
  {
    path: '/learning/video',
    component: resolve => require(['@/views/learning/video/video'], resolve),
    name: 'learnVideo',
    meta: {
      title: '学习课堂'
    }
  },
  {
    path: '/learning/live',
    component: resolve => require(['@/views/learning/video/live'], resolve),
    name: 'learnLive',
    meta: {
      title: '学习课堂'
    }
  },
  {
    path: '/learning/pdf',
    component: resolve => require(['@/views/learning/video/pdf'], resolve),
    name: 'learnPdf',
    meta: {
      title: '学习课堂'
    }
  },
  {
    path: '/teacher',
    component: resolve => require(['@/views/teacher/index'], resolve),
    redirect: '/teacher/index',
    children: [
      {
        path: '/teacher/index',
        component: resolve => require(['@/views/teacher/info'], resolve),
        name: 'teacher',
        meta: {
          title: '班级管理'
        }
      },
      {
        path: '/teacher/statistics',
        component: resolve => require(['@/views/teacher/statistics'], resolve),
        name: 'Tstatistics',
        meta: {
          title: '班级管理'
        }
      },
      {
        path: '/teacher/statisticsList',
        component: resolve => require(['@/views/teacher/statistics/list'], resolve),
        name: 'statisticsList',
        meta: {
          title: '班级管理'
        }
      },
      {
        path: '/teacher/statisticsCourse',
        component: resolve => require(['@/views/teacher/statistics/course'], resolve),
        name: 'statisticsCourse',
        meta: {
          title: '班级管理'
        }
      },
      {
        path: '/teacher/myClass',
        component: resolve => require(['@/views/teacher/myClass'], resolve),
        name: 'myClass',
        meta: {
          title: '班级管理'
        }
      },
      {
        path: '/teacher/myClassList',
        component: resolve => require(['@/views/teacher/myclass/list'], resolve),
        name: 'myClassList',
        meta: {
          title: '班级管理'
        }
      },
      {
        path: '/teacher/work',
        component: resolve => require(['@/views/teacher/work'], resolve),
        name: 'Thomework',
        meta: {
          title: '班级管理'
        }
      },
      {
        path: '/teacher/workList',
        component: resolve => require(['@/views/teacher/work/list'], resolve),
        name: 'workList',
        meta: {
          title: '班级管理'
        }
      },
      {
        path: '/teacher/workExamine',
        component: resolve => require(['@/views/teacher/work/examine'], resolve),
        name: 'workExamine',
        meta: {
          title: '班级管理'
        }
      },
      {
        path: '/teacher/course',
        component: resolve => require(['@/views/teacher/course'], resolve),
        name: 'Tcourse',
        meta: {
          title: '班级管理'
        }
      },
      {
        path: '/teacher/courseList',
        component: resolve => require(['@/views/teacher/course/list'], resolve),
        name: 'courseList',
        meta: {
          title: '班级管理'
        }
      },
      {
        path: '/teacher/examine',
        component: resolve => require(['@/views/teacher/examine'], resolve),
        name: 'Texamine',
        meta: {
          title: '班级管理'
        }
      },
      {
        path: '/teacher/examineList',
        component: resolve => require(['@/views/teacher/examine/list'], resolve),
        name: 'TexamineList',
        meta: {
          title: '班级管理'
        }
      },
      {
        path: '/teacher/message',
        component: resolve => require(['@/views/teacher/message'], resolve),
        name: 'Tmessage',
        meta: {
          title: '班级管理'
        }
      }
    ]
  },
  {
    path: '/online',
    component: resolve => require(['@/views/online/index'], resolve),
    name: 'course',
    meta: {
      title: '排行榜'
    }
  },
  {
    path: '/course',
    component: resolve => require(['@/views/course/index'], resolve),
    name: 'course',
    meta: {
      title: '课程中心'
    }
  },
  {
    path: '/specialTraining',
    redirect: '/specialTraining/index'
  },
  {
    path: '/specialTraining/index',
    component: resolve => require(['@/views/specialTraining/index'], resolve),
    name: 'specialTraining',
    meta: {
      title: '专题培训'
    }
  },
  {
    path: '/specialTraining/detail',
    component: resolve => require(['@/views/specialTraining/detail'], resolve),
    name: 'specialTrainingDetail',
    meta: {
      title: '专题培训详情'
    }
  },
  {
    path: '/exam',
    component: resolve => require(['@/views/exam/index'], resolve),
    name: 'exam',
    meta: {
      title: '在线考试'
    }
  },
  {
    path: '/exam/question',
    component: resolve => require(['@/views/exam/question'], resolve),
    name: 'question',
    meta: {
      title: '在线考试'
    }
  },
  {
    path: '/exam/review',
    component: resolve => require(['@/views/exam/review'], resolve),
    name: 'review',
    meta: {
      title: '在线考试'
    }
  },
  {
    path: '/estimate',
    component: resolve => require(['@/views/estimate/index'], resolve),
    name: 'estimate',
    meta: {
      title: '质量评估'
    }
  }
]
const router = new Router({
  mode: process.env.VUE_APP_MODE, // 根绝环境变量来区分是打包成APP还是网页版查看,history和mode模式
  routes: constantRouteMap
})

router.beforeEach((to,from,next)=>{ //beforeEach是router的钩子函数，在进入路由前执行
  if(to.meta.title){ //判断是否有标题
    document.title = to.meta.title
  }
  next()  //执行进入路由，如果不写就不会进入目标页
})

export default router
